import React, {Fragment} from 'react';
import {UI} from 'components';
import css from './list-items.scss';
import {toggleListItem} from "store/lists";

export function ListItemCheckbox({ item }) {
  return (
    item.name &&
    <Fragment>
      <UI.Checkbox
        className={css.checkbox}
        checked={item.status === 'Completed'}
        onClick={() => toggleListItem(item.id)}
      />
      <span>{ item.name }</span>
    </Fragment>
  );
}
